<template>
    <div v-if="ready">
        <form
            class="form-horizontal"
            enctype="multipart/form-data"
            @keydown="form.errors.clear($event.target.name)"
            autocomplete="off"
        >
            <!-- Document name -->
            <form-input :form="form" name="name" required></form-input>

            <!-- Document types -->
            <backend-select
                v-model="selected_document_type"
                :value="field('document_type_id')"
                :route="route('document-types.index')"
                :error="form.errors.get('document_type_id')"
                name="document_type"
                objectNameKey="description"
                :placeholder="uLang('app.misc')"
            />

            <!-- Description -->
            <form-input v-if="isDescriptionEditable" :form="form" name="description"></form-input>

            <!-- Types that are allowed to view document -->
            <backend-select
                v-model="form.allowed_relation_type_ids"
                :value="field('allowed_relation_type_ids')"
                :route="route('types.index')"
                :error="form.errors.get('allowed_relation_type_ids')"
                return="id"
                name="relation_types"
                label="visible_to"
                multiple
            />
        </form>

        <div class="form-group">
            <input :disabled="form.busy" type="button" @click.prevent="store" class="btn btn-brand"
                   :value="uLang('app.save')"/>
        </div>
    </div>
</template>

<script>
    import Form from '~/Form/Form'
    import FormMixin from '~/mixins/form'

    export default {
        name: 'document-form',
        mixins: [FormMixin],
        props: {
            id: {
                type: Number,
                required: true
            },
        },
        data() {
            return {
                entity: 'document',
                form: new Form({
                    name: '',
                    document_type_id: null,
                    description: '',
                    allowed_relation_type_ids: null
                }),
                document: {},
                selected_document_type: null,
            }
        },
        created() {
            this.$on('afterRetrieve', this.afterRetrieve);
            this.$on('afterUpdate', this.afterUpdate);
        },
        computed: {
            isDescriptionEditable() {
                return !this.form.document_type_id;
            }
        },
        watch: {
            selected_document_type(type) {
                // Can only set allowed_relation_type_ids if document type is empty or used to be empty
                if (!type || type.id !== this.form.document_type_id) {
                    let relationTypes = $filledOrNull($getOrNull(['relation_types'], type))
                    this.form.allowed_relation_type_ids = Array.isArray(relationTypes) ? relationTypes.map(t => t.id).sort() : null
                }
                this.form.description = type ? type.description : ''
                this.form.document_type_id = type ? type.id : null
            },
        },
        methods: {
            afterRetrieve(data) {
                this.document = data
                this.selected_document_type = data.document_type

                let documentRelationTypes = $filledOrNull($getOrNull(['relation_types'], data))
                let documentTypeRelationTypes = $filledOrNull($getOrNull(['document_type', 'relation_types'], data))

                this.form.allowed_relation_type_ids = $parseStringify(documentRelationTypes) || $parseStringify(documentTypeRelationTypes) || []
            },
            afterUpdate(data) {
                this.$emit('documentUpdated', data)
            },
        }
    }
</script>
